// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__oZhIe","small":"Loader_small__v3ZAB"};